var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGradientT(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80px",
    height: "93px",
    viewBox: "0 0 80 93",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "10.0817576%",
    y1: "-66.9026693%",
    x2: "77.8686856%",
    y2: "119.091797%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#37F6CC",
    offset: 0
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "offset",
    values: "0;-2.5",
    dur: "15s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#37F6CC",
    offset: 0.5
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "offset",
    values: "0.5;-2",
    dur: "15s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8F386",
    offset: 1
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "offset",
    values: "1;-1.5",
    dur: "15s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e2d989",
    offset: 1.5
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "offset",
    values: "1.5;-1",
    dur: "15s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8F386",
    offset: 2
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "offset",
    values: "2;-0.5",
    dur: "15s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#37F6CC",
    offset: 2.5
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "offset",
    values: "2.5;0",
    dur: "15s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#37F6CC",
    offset: 3
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "offset",
    values: "3;0.5",
    dur: "15s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8F386",
    offset: 3.5
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "offset",
    values: "3.5;1",
    dur: "15s",
    repeatCount: "indefinite"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M32.9401298,38.0772913 L32.9401298,62.9005465 C32.9401298,65.7051819 34.0873269,67.4831868 36.3779223,68.2289818 C38.1120132,68.7962323 40.6894079,69.0677686 44.1158044,69.0435907 C46.0778152,69.0324317 47.6922482,70.553779 47.6922482,72.4749915 L47.6922482,84.8633711 C47.6922482,86.6655539 46.2601512,88.1590037 44.4253956,88.2947718 C32.5184779,89.1781948 24.1557153,87.7944755 19.3352085,84.1473335 C14.0835532,80.17472 11.4586752,73.0924576 11.4586752,62.9005465 L11.4586752,38.0772913 L3.79866572,38.0772913 C1.69990291,38.0772913 0,36.4108766 0,34.3576157 L0,21.602848 C0,19.5477273 1.69990291,17.8831724 3.79866572,17.8831724 L11.4586752,17.8831724 L11.4586752,10.5256541 C11.4586752,5.87977923 14.5697824,1.78441639 19.1129866,0.450912682 C26.0037662,-1.57445069 32.9401298,3.47686879 32.9401298,10.5256541 L32.9401298,17.8831724 L43.8935824,17.8831724 C45.9904459,17.8831724 47.6922482,19.5477273 47.6922482,21.602848 L47.6922482,34.3576157 C47.6922482,36.4108766 45.9904459,38.0772913 43.8935824,38.0772913 L32.9401298,38.0772913 Z",
    id: "path"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-1)",
    xlinkHref: "#path"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#37F6CC",
    cx: 66.4284885,
    cy: 80.0382683,
    rx: 11.923062,
    ry: 11.9205932
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGradientT);
export default __webpack_public_path__ + "static/media/gradient_t.d447037ead7bc7dc89f0acad8c620bfa.svg";
export { ForwardRef as ReactComponent };